import SEO from "@/components/SEO";
import { useSite } from "@/context/SiteContext";

export default function NotFound() {
  const { openQuote } = useSite();
  return (
    <>
      <SEO
        title="Pagina nu a fost găsită | BROX CONSTRUCT"
        description="Pagina căutată nu există. Cere ofertă pe WhatsApp sau revino la pagina principală BROX CONSTRUCT."
        path="/404"
      />
      <section className="grain flex min-h-[72vh] items-center bg-ink-950 pb-20 pt-32">
        <div className="container-brox">
          <p className="eyebrow mb-5">EROARE 404</p>
          <h1 className="display-title text-5xl sm:text-7xl" data-testid="notfound-title">
            PAGINA NU A FOST GĂSITĂ.
          </h1>
          <p className="mt-5 max-w-xl text-base text-muted-foreground sm:text-lg" data-testid="notfound-subtitle">
            Dar proiectul tău poate începe de aici.
          </p>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <a href="/" className="btn-ghost" data-testid="notfound-home-btn">
              ÎNAPOI ACASĂ
            </a>
            <button onClick={() => openQuote({ source: "404" })} className="btn-primary copper-sheen" data-testid="notfound-quote-btn">
              CERE OFERTĂ
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
